module.exports = __webpack_public_path__ + "img/jiayou.42d19dea.png";